<script>
	import { viewsXpages, registerXpage } from './../stores/store.js';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

// pageActual=0; loadData();
    function load() {
		dispatch('load', {});
	}

</script>


<button
class="btn btn-secondary dropdown-toggle"
type="button"
data-bs-toggle="dropdown"
aria-expanded="false"
>{$viewsXpages}</button>

<ul class="dropdown-menu dropdown-menu-dark">
    {#each $registerXpage as reg}
    <!-- svelte-ignore a11y-missing-attribute -->
    <li><a class="dropdown-item" on:click={() => { $viewsXpages=reg; load(); }}>{reg}</a></li>
    {/each}
</ul>